module.exports = __webpack_public_path__ + "img/logoSgp.dadd638a.png";